import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { useFirebase } from "./contexts/FirebaseContext";
import Header from "./components/Header";
import Modal from "./components/Modal";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import Login from "./pages/console/Login";
import Home from "./pages/Home";
import ForgotPassword from "./pages/console/ForgotPassword";
import Contact from "./pages/console/Contact";
import Dashboard from "./pages/console/Dashboard";

const App = () => {
	const { user } = useFirebase();

	return (
		<Router>
			<Header />
			<Modal />

			<div className="flex-1">
				<Routes>
					{/* Public */}
					<Route
						path="/"
						element={<Home />}
					/>

					<Route
						path="/c/login"
						element={
							<PublicRoute>
								<Login />
							</PublicRoute>
						}
					/>

					{/* Protected console routes */}
					<Route
						path="/c/dashboard"
						element={
							<PrivateRoute>
								<Dashboard />
							</PrivateRoute>
						}
					/>

					{/* fallback */}
					<Route
						path="*"
						element={<Navigate to="/" />}
					/>

					{/* <Route
            path="/c/forgot-password"
            element={
              <PrivateRoute>
                <ForgotPassword />
              </PrivateRoute>
            }
          /> */}

					{/* <Route
						path="/c/contact"
						element={
							<PrivateRoute>
								<Contact />
							</PrivateRoute>
						}
					/> */}
				</Routes>
			</div>
		</Router>
	);
};

export default App;
